export const localeEn = {
    min: (min: string): string => `Min ${min}`,
    max: (max: string): string => `Max ${max}`,
    isEmail: "Invalid Email",
    required: "Required",
    alphanumeric: "Value needs to be alphanumeric ( 0~9, a~Z )",
    noSpecials: "Must not contain special symbols (!@$%...etc)",
    isUUIDv4: "Value needs to be a v4 UUID",
    isSameAs: "Value does not match",
};
